import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { debounce } from "lodash";
import polyline from "polyline";
import { toast } from "react-toastify";
import { Grid, Box } from "@mui/material";
import {
  getAutoComplete,
  getClearAutocomplete,
  getClearDirection,
  getDirection,
  getGeocode,
  getLocationCheck,
  getNearBySearch,
  getPlaceDetails,
} from "redux/actions/UserGoogleMap"; //done
import {
  getClearRateCalculation,
  getRateCalculation,
  getRentalSlab,
  getTripCheckout,
  getTripSlab,
} from "redux/actions/UserCustomerTrip"; //done
// import Map from "pages/Map/Map";
import BookACab from "./BookACab"; //done
import {
  airportData,
  oneWayData,
  outStationData,
  rentalData,
} from "./RideTypeData"; //done
import { toastObject, tripEnumObject } from "utils/enumObject"; //done
import BackDrop from "components/backDrop/BackDrop";
import Loader from "components/loader/Loader";
import UserDetails from "./userDetails/UserDetails";

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const type = searchParams.get("type");
  const status =
    type === tripEnumObject?.rental
      ? "Rental"
      : type === tripEnumObject?.airport
      ? "Airport"
      : type === tripEnumObject?.outStationRound
      ? "Outstation"
      : "Oneway";
  const [buttonPresent, setButtonPresent] = useState(true);
  const [currentLat, setCurrentLat] = useState("");
  const [currentLong, setCurrentLong] = useState("");
  const [pickup, setPickup] = useState({});
  const [drop, setDrop] = useState({});
  const [rentalPackage, setRentalPackage] = useState();
  const [decodedPoints, setDecodedPoints] = useState([]);
  const [value, setValue] = useState(type ? type : tripEnumObject?.oneWay);
  const [directionData, setDirectionData] = useState("");
  const sessionPickup = sessionStorage.getItem("pickup");
  const sessionDrop = sessionStorage.getItem("drop");
  const dateOne = sessionStorage.getItem("date");
  const endDateOne = sessionStorage.getItem("endDate");
  const packageValue = sessionStorage.getItem("package");

  const [needPlacard, setNeedPlacard] = useState(() => sessionStorage.getItem("needPlacard") === "true");
  const [placardText, setPlacardText] = useState(() => sessionStorage.getItem("placardText") || '');

    const [travellerData, setTravellerData] = useState(() => {
    const stored = sessionStorage.getItem("userDetails");
    return stored 
      ? JSON.parse(stored)
      : { firstName: '', lastName: '', phoneNumber: '', countryCode: "+91" , email: ''};
  });
    const [bookingData, setBookingData] = useState(null);
  
    const handleTravellerSubmit = (data) => {
      setTravellerData(data);
      sessionStorage.setItem("userDetails", JSON.stringify(data));
    };
  
    const handleBookingSubmit = (data) => {
      setBookingData(data);
    };
  
    const handleFinalSubmit = () => {
      // Validate both sections
      if (!travellerData.email || !travellerData.name || !travellerData.phoneNumber) {
        toast.error('Please fill in all traveller details');
        return;
      }
  
      if (!bookingData) {
        toast.error('Please complete the booking details');
        return;
      }
  
      // Combine data and submit
      const finalData = {
        traveller: travellerData,
        booking: bookingData
      };
  
      console.log('Final Submission:', finalData);
      
      // Your submission logic here
      // navigate to confirmation page or submit to API
    };
  const bufferTime = useSelector(
    (state) => state.userRentalSlab?.userRentalSlab?.data?.bookingBuffer
  );
  const currentDate = new Date();
  const [date, setDate] = useState(
    dateOne
      ? dayjs(dateOne)
      : dayjs(
          currentDate.setMinutes(
            Math.ceil(currentDate.getMinutes() / 10) * 10 +
              (bufferTime || 600) / 60
          )
        )
  );
  const [endDate, setEndDate] = useState(
    endDateOne
      ? dayjs(endDateOne)
      : dayjs(
          currentDate.setMinutes(
            Math.ceil(currentDate.getMinutes() / 10) * 10 + 3600 / 60
          )
        )
  );
  const timeSlabData = useSelector(
    (state) => state?.userTripSlab?.userTripSlab?.data
  );

  const token = localStorage.getItem("token");
  const isEdit = localStorage.getItem("isEdit");
  const locationData =
    useSelector(
      (state) => state.userAutoComplete?.userAutoComplete?.data?.predictions
    ) || [];
  useEffect(() => {
    sessionStorage.setItem("decodedPoints", JSON.stringify(decodedPoints));
  }, [decodedPoints]);

  const tripCheckoutData = useSelector(
    (state) => state?.userTripCheckout?.userTripCheckout?.data
  );
  const tripCheckoutLoader = useSelector(
    (state) => state?.userTripCheckout?.loading
  );
  // polyline conversion
  const polylineData = decodedPoints?.map((points) => ({
    lat: points?.[0],
    lng: points?.[1],
  }));
  sessionStorage.setItem("paths", JSON.stringify(polylineData));
  const trip = localStorage.getItem("trip");
  const sourceAddress = decodedPoints.at(0);
  const destinationAddress = decodedPoints.at(-1);
  const dropLatLng = useSelector(
    (state) =>
      state?.userPlaceDetails?.drop?.drop?.data?.result?.geometry?.location
  );
  const pickupLatLng =
    useSelector(
      (state) =>
        state?.userPlaceDetails?.pickup?.pickup?.data?.result?.geometry
          ?.location
    ) || [];
  const pickupLoader = useSelector((state) => state.userPlaceDetails?.loading);
  sessionStorage.setItem("pickupLatLng", JSON.stringify([pickupLatLng]));
  const currentLocationData =
    useSelector((state) => state.userGeocode?.userGeocode?.results) || [];
  const locationLoader = useSelector((state) => state.userGeocode?.loading);
  const [currentLoader, setCurrentLoader] = useState(locationLoader || false);
  const rentalSlabData =
    useSelector((state) => state.userRentalSlab?.userRentalSlab?.data?.body) ||
    [];
  const nearbySearchData =
    useSelector(
      (state) => state.userNearBySearch?.userNearBySearch?.data?.results
    ) || [];
  const airportOptionData =
    rentalSlabData?.length > 0 &&
    rentalSlabData
      ?.map((item) => {
        if (item?.terminal && item.name) {
          return {
            id: item?.id,
            name: item?.terminal + " " + item?.name,
            label: item?.terminal + " " + item?.name,
            place_id: item?.placeId,
            geoPoint: item?.geoPoint,
          };
        } else {
          return null;
        }
      })
      .filter(Boolean);
  const optionData =
    rentalSlabData?.length > 0 &&
    rentalSlabData
      ?.map((item) => {
        if (item?.maxTime && item?.maxDistance) {
          return {
            id: item?.id,
            name: item?.maxTime + " hr " + item?.maxDistance + " km",
            label: item?.maxTime + " hr " + item?.maxDistance + " km",
          };
        } else {
          return null;
        }
      })
      .filter(Boolean);
  let defaultValues = {
    pickup: sessionPickup ? JSON.parse(sessionPickup) : pickup,
    drop: sessionDrop ? JSON.parse(sessionDrop) : drop,
    date: date
      ? date
      : dayjs(
          currentDate.setMinutes(
            Math.ceil(currentDate.getMinutes() / 10) * 10 +
              (bufferTime || 600) / 60
          )
        ),
    endDate: endDate
      ? endDate
      : dayjs(
          currentDate.setMinutes(
            Math.ceil(currentDate.getMinutes() / 10) * 10 + 3600 / 60
          )
        ),
    package: packageValue ? JSON.parse(packageValue) : {},
  };
  useEffect(() => {
    if (currentLocationData?.length > 0) {
      setCurrentLoader(false);
      setPickup(currentLocationData[0]);
      if (value == tripEnumObject?.rental) {
        const rentalDataVal = {
          sourceAddress: currentLocationData[0]?.formatted_address || "",
          type: value,
        };
        if (rentalDataVal?.sourceAddress) {
          dispatch(getRentalSlab(rentalDataVal));
        }
      }
      sessionStorage.setItem("pickup", JSON.stringify(currentLocationData[0]));
      defaultValues = { ...defaultValues, pickup: currentLocationData[0] };
    }
  }, [currentLocationData]);

  const onInputChangeVal = debounce((event, input, name) => {
    if (
      (input !== " " && name === "pickup") ||
      value === tripEnumObject.outStationRound
    ) {
      const data = {
        name: input,
        sessiontoken: "",
        location: currentLat ? currentLat + "," + currentLong : "",
      };
      if (input?.length > 2) {
        dispatch(getAutoComplete(data));
      }
    } else if (name === "drop" && value === tripEnumObject.oneWay) {
      if (input !== "") {
        const data = {
          name: input,
          location: pickupLatLng || currentLat || "",
        };
        if (
          event?.type === "change" &&
          input?.length > 2 &&
          data?.location !== undefined
        ) {
          dispatch(getNearBySearch(data));
        }
      }
    }
  }, 500);
  useEffect(() => {
    if (dateOne === null || "") {
      sessionStorage.setItem(
        "date",
        dayjs(
          currentDate.setMinutes(
            Math.ceil(currentDate.getMinutes() / 10) * 10 +
              (bufferTime || 600) / 60
          )
        )
      );
    }
    if (endDateOne === null || "") {
      sessionStorage.setItem(
        "endDate",
        dayjs(
          currentDate.setMinutes(
            Math.ceil(currentDate.getMinutes() / 10) * 10 + 3600 / 60
          )
        )
      );
    }
  }, []);
  const onCurrentAddress = debounce(() => {
    setCurrentLoader(true);
    navigator.geolocation.getCurrentPosition(
      function (position) {
        setCurrentLat(position?.coords?.latitude);
        setCurrentLong(position?.coords?.longitude);
        const data = {
          latlng: position?.coords?.latitude
            ? position?.coords?.latitude + "," + position?.coords?.longitude
            : "",
        };
        dispatch(getGeocode(data));
      },
      function (errors) {
        toast.info("Please enable location permission and try again", {
          autoClose: toastObject?.infoAutoClose,
        });
        setCurrentLoader(false);
      },
      {
        enableHighAccuracy: true,  // This forces high accuracy location
        timeout: 10000,  // Time in milliseconds before it times out
        maximumAge: 0   // Prevents caching by always asking for fresh data
      }
    );
  }, 500);

  const onHandleChange = (event, value, name) => {
    if (name === "pickup") {
      setPickup(value);
      sessionStorage.setItem("pickup", JSON.stringify(value));
    } else if (name === "drop") {
      if (type === tripEnumObject?.outStationRound) {
        let source = JSON.parse(sessionPickup);
        const payload = {
          sourceAddress: source?.description,
          destinationAddress: value?.description,
          type: type,
          location: "",
        };
        dispatch(getLocationCheck(payload));
      }
      setDrop(value);
      sessionStorage.setItem("drop", JSON.stringify(value));
    }
  };

  const handleTabChange = debounce((event, newValue) => {
    dispatch(getClearDirection());
    setDecodedPoints([]);
    localStorage.removeItem("type");
    localStorage.removeItem("trip");
    sessionStorage.removeItem("drop");
    sessionStorage.removeItem("pickupLatLng");
    sessionStorage.removeItem("paths");
    sessionStorage.removeItem("decodedPoints");
    setNeedPlacard(false);
    setPlacardText('');
    sessionStorage.removeItem("needPlacard");
    sessionStorage.removeItem("placardText");
    if (!pickup?.address_components) {
      sessionStorage.removeItem("pickup");
      setPickup(null);
      setPickupLocation([]);
    }
    setDrop(null);
    setDirectionData("");
    setValue(newValue);
    setDate("");
    setButtonPresent(true);
    setSearchParams({ type: newValue });

    sessionStorage.setItem(
      "date",
      dayjs(
        currentDate.setMinutes(
          Math.ceil(currentDate.getMinutes() / 10) * 10 +
            (bufferTime || 600) / 60
        )
      )
    );
  }, 200);

  useEffect(() => {
    const payload = {
      type: value,
      sourceAddress: pickup?.formatted_address || pickup?.description || "",
    };
    if (value === tripEnumObject?.oneWay || payload?.sourceAddress) {
      dispatch(getTripSlab(payload));
    }
  }, [value, pickup]);

  const onChangeDate = (e, name) => {
    if (name === "date" && !isNaN(e?.$D)) {
      setDate(dayjs(e));
      sessionStorage.setItem("date", dayjs(e).toISOString());
    }
    if (name === "endDate" && !isNaN(e?.$D)) {
      setEndDate(dayjs(e));
      sessionStorage.setItem("endDate", dayjs(e).toISOString());
    }
  };

  useEffect(() => {
    if (
      pickup &&
      drop &&
      (value === tripEnumObject?.oneWay || value === tripEnumObject?.airport)
    ) {
      setButtonPresent(false);
    } else if (
      pickup &&
      value === tripEnumObject?.rental &&
      (rentalPackage || JSON.parse(packageValue)?.id)
    ) {
      setButtonPresent(false);
    } else if (
      (pickup && drop && value === tripEnumObject?.outStationRound) ||
      rentalPackage ||
      JSON.parse(packageValue)?.id
    ) {
      setButtonPresent(false);
    } else {
      setButtonPresent(true);
    }
  }, [pickup, drop, rentalPackage]);

  // direction data and decode the points
  const directionDataPoints = useSelector(
    (state) =>
      state?.userDirection?.userDirection?.data?.routes?.[0]?.overview_polyline
        ?.points
  );
  const directionDataResponse = useSelector(
    (state) => state?.userDirection?.userDirection?.data?.routes?.[0]?.legs?.[0]
  );
 // const distanceValue = Math.ceil(directionData?.distance?.value / 1000);
  const distanceValue=Number(directionData?.distance?.value  ? (directionData.distance.value / 1000).toFixed(2)   : 0.00)
  //rate caluculation
  const rateCalculationData = useSelector(
    (state) => state?.userRateCalculation?.userRateCalculation?.data?.data
  );
  const rideInclusion = useSelector(
    (state) =>
      state?.userRateCalculation?.userRateCalculation?.data?.rideInclusions
  );
  const rateCalculationLoader = useSelector(
    (state) => state?.userRateCalculation?.loading
  );
  const [pickLocation, setPickupLocation] = useState(pickupLatLng);
  sessionStorage.setItem("rideInclusion", JSON.stringify(rideInclusion));
  useEffect(() => {
    if (directionDataPoints) {
      const decoded = polyline.decode(directionDataPoints);
      setDecodedPoints(decoded);
      setDirectionData(directionDataResponse);
    }
  }, [directionDataPoints]);

  // call the direction api
  useEffect(() => {
    let sessionDestination = JSON.parse(sessionDrop)?.geoPoint?.coordinates;
    let dropLatLngVar = dropLatLng;
    if(value === tripEnumObject?.airport && sessionDestination && sessionDestination.length > 0){
      dropLatLngVar = { lat: sessionDestination[0], lng: sessionDestination[1] };
    }
    const latLngData = {
      origin: pickupLatLng,
      destination: dropLatLngVar
    };
    const debouncedDispatch = debounce(() => {
      if (pickupLatLng?.lat && latLngData?.destination && !trip) {
        dispatch(getDirection(latLngData));
      }
    }, 1000);
    setPickupLocation(pickupLatLng);
    debouncedDispatch();
  }, [pickupLatLng, dropLatLng]);
  useEffect(() => {
    if (
      !trip &&
      (value === tripEnumObject?.rental || value === tripEnumObject?.airport)
    ) {
      const rentalDataVal = {
        type: value,
        sourceAddress:
          pickup?.formatted_address ||
          pickup?.description ||
          defaultValues?.pickup?.formatted_address ||
          defaultValues?.pickup?.description ||
          "",
      };
      if (value === tripEnumObject?.oneWay || rentalDataVal?.sourceAddress) {
        dispatch(getRentalSlab(rentalDataVal));
      }
    }
  }, [pickup, value]);

  // Track whether placard text exists (not the text itself) to avoid re-calling on every keystroke
  const hasPlacardText = !!(needPlacard && placardText);

  useEffect(() => {
    if (!trip) {
      // Determine current placard text for API (only for rental/airport)
      const currentPlacardText = hasPlacardText ? placardText : "";
      if (
        directionData &&
        dateOne &&
        (value === tripEnumObject?.oneWay || value === tripEnumObject?.airport)
      ) {
        const payload = {
          type: value,
          distance: distanceValue,
          startTime: dateOne,
          eta: parseFloat(directionData?.duration?.value) / 3600,
          sourceAddress: directionData?.start_address,
          destinationAddress: value === tripEnumObject?.airport ? JSON.parse(sessionDrop)?.label : directionData?.end_address,
          ...(value === tripEnumObject?.airport && { placardText: currentPlacardText }) ,
        };
        const debouncedDispatch = debounce(() => {
          dispatch(getRateCalculation(payload));
        }, 1000);
        debouncedDispatch();
      } else if (
        value === tripEnumObject?.rental &&
        (rentalPackage || packageValue) &&
        (directionData?.start_address ||
          pickup?.formatted_address ||
          pickup?.description ||
          defaultValues.pickup?.description ||
          defaultValues.pickup?.formatted_address)
      ) {
        const payload = {
          type: value,
          rateCardTypeId: rentalPackage || JSON.parse(packageValue)?.rateCardTypeId || JSON.parse(packageValue)?.id,
          startTime: dateOne,
          sourceAddress:
            directionData?.start_address ||
            pickup?.formatted_address ||
            pickup?.description ||
            defaultValues.pickup?.description ||
            defaultValues.pickup?.formatted_address,
          placardText: currentPlacardText,
        };
        const debouncedDispatch = debounce(() => {
          dispatch(getRateCalculation(payload));
        }, 1000);
        debouncedDispatch();
      } else if (
        value === tripEnumObject?.outStationRound &&
        directionData &&
        dateOne &&
        endDate
      ) {
        const payload = {
          type: tripEnumObject?.outStationRound,
          distance: distanceValue,
          startTime: dateOne,
          expectedReturnTime: endDate,
          eta: parseFloat(directionData?.duration?.value) / 3600,
          sourceAddress: directionData?.start_address,
          destinationAddress: directionData?.end_address,
        };
        const debouncedDispatch = debounce(() => {
          dispatch(getRateCalculation(payload));
        }, 1000);
        debouncedDispatch();
      }
    }
  }, [directionData, dateOne, rentalPackage, pickup, endDateOne, hasPlacardText]);

  const placeDetail = (type, data) => {
    const inputData = {
      type: type,
      place_id: JSON.parse(data)?.place_id,
    };
    if (inputData?.place_id !== undefined) {
      dispatch(getPlaceDetails(inputData));
    }
  };

  useEffect(() => {
    if (!trip) {
      placeDetail("pickup", sessionPickup);
      placeDetail("drop", sessionDrop);
    }

    if (sessionPickup && value == tripEnumObject?.rental) {
      const rentalDataVal = {
        sourceAddress:
          JSON.parse(sessionPickup)?.formatted_address ||
          JSON.parse(sessionPickup)?.description ||
          "",
        type: value,
      };
      if (rentalDataVal?.sourceAddress) {
        dispatch(getRentalSlab(rentalDataVal));
      }
    }
  }, [sessionPickup, sessionDrop, trip]);

  const onSubmitBtn = (data, code) => {
    if (value === tripEnumObject?.rental) {
      setRentalPackage(data.package);
      if (currentLocationData?.length > 0 && pickup?.formatted_address) {
        const payload = {
          type: value,
          rateCardTypeId: rentalPackage || JSON.parse(packageValue)?.rateCardTypeId || JSON.parse(packageValue)?.id,
          sourceAddress: pickup?.formatted_address,
          startTime: dateOne,
          placardText: (needPlacard && placardText) ? placardText : "",
        };
        dispatch(getRateCalculation(payload));
      } else {
        placeDetail("pickup", pickup);
      }
    } else {
      placeDetail("pickup", pickup);
      placeDetail("drop", drop);
      setButtonPresent(false);
    }
  };
  const onClickCab = (data) => {
    const packageData = JSON.parse(sessionStorage.getItem("package")) || {};
    const rateCardTypeId = packageData?.rateCardTypeId || "";
    navigate(
      `/rideDetails?type=${value}&distance=${distanceValue}&sourceLat=${
        value === "3" ? pickupLatLng?.lat : sourceAddress?.[0]
      }&sourceLng=${
        value === "3" ? pickupLatLng?.lng : sourceAddress?.[1]
      }&destinationLat=${destinationAddress?.[0]}&destinationLng=${
        destinationAddress?.[1]
      }&eta=${parseFloat(directionData?.duration?.value) / 3600}&rateId=${
        data?.id
      }&carId=${data?.id}&rateId=${data?.id}&rateCardTypeId=${rateCardTypeId}`
    );
    sessionStorage.setItem("tripPrice", JSON.stringify(data));
  };

  const handleInput = (e, value) => {
    setRentalPackage(e.target.value);
  };
  const formData = (value, trip) => {
    switch (value) {
      case tripEnumObject?.rental:
        return rentalData(optionData?.length > 0 ? optionData : [], trip);
      case tripEnumObject?.airport:
        return airportData(
          airportOptionData?.length > 0 ? airportOptionData : [],
          trip
        );
      case tripEnumObject?.outStationRound:
        return outStationData(trip);
      default:
        return oneWayData(trip);
    }
  };
  useEffect(() => {
    dispatch(getClearAutocomplete());
    dispatch(getClearDirection());
    dispatch(getClearRateCalculation());
  }, [value]);
  return (
     <Box className="max-h-screen bg-gray-50">
      <div className='max-h-screen p-6 bg-white'>
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={2}
        sx={{
          px: { xs: 0, sm: 8 }, // 0 padding on mobile, 8 on tablet/desktop
        }}
        >
          <>
            <Grid item xs={12} className="h100Scroll">
              <Grid item xs={12}>
                  <UserDetails 
                    onSubmit={handleTravellerSubmit}
                    initialData={travellerData}
                  />
              </Grid>
              <BookACab
                formData={formData(value, trip)}
                optionData={optionData?.length > 0 ? optionData : []}
                airportOptionData={
                  airportOptionData?.length > 0 ? airportOptionData : []
                }
                onInputChangeVal={onInputChangeVal}
                locationData={locationData}
                nearbySearchData={nearbySearchData}
                onCurrentAddress={onCurrentAddress}
                currentLat={currentLat}
                currentLong={currentLong}
                defaultTripValues={defaultValues}
                btnEnable={buttonPresent}
                token={token}
                onSubmitBtn={onSubmitBtn}
                onHandleChange={onHandleChange}
                rateCalculationData={rateCalculationData}
                rateCalculationLoader={rateCalculationLoader}
                onClickCab={onClickCab}
                value={value}
                timeSlabData={timeSlabData}
                handleTabChange={handleTabChange}
                tripCheckoutData={tripCheckoutData}
                onChangeDate={onChangeDate}
                currentLoader={currentLoader}
                handleInput={handleInput}
                bufferTime={bufferTime}
                noscroll={"true"}
                pageType="homeForm"
                needPlacard={needPlacard}
                setNeedPlacard={setNeedPlacard}
                placardText={placardText}
                setPlacardText={setPlacardText}
              />
            </Grid>
          </>
        </Grid>
      </div>
    </Box>
  );
};
export default Home;
